import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import themeReducer from './themeReducer';
import administrationToolsReducer from './administrationToolsReducer';
import { activeLayersReducer, surveyDataManagerUiReducer } from './surveyDataManager';

export const store = configureStore({
  reducer: {
    user: userReducer,
    theme: themeReducer,
    administrationTools: administrationToolsReducer,
    surveyDataManagerActiveLayers: activeLayersReducer,
    surveyDataManagerUi: surveyDataManagerUiReducer,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;
